import { render } from "./Album.vue?vue&type=template&id=496a0f08&scoped=true"
import script from "./Album.vue?vue&type=script&lang=js"
export * from "./Album.vue?vue&type=script&lang=js"

import "./Album.vue?vue&type=style&index=0&id=496a0f08&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496a0f08"]])

export default __exports__